var _ellipse, _path, _path2, _ellipse2, _ellipse3, _g, _path3, _path4, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlant(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 120,
    viewBox: "0 0 86 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.6438,
    cy: 116.465,
    rx: 20.6402,
    ry: 3.49217,
    fill: "#042A44"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.4606 108.089L29.9768 90.9158C29.9476 90.7932 29.9326 90.664 29.9326 90.5338C29.9326 89.9046 30.2744 89.3945 30.6959 89.3945H60.5915C60.6787 89.3945 60.7652 89.4168 60.8474 89.4605C61.2446 89.6715 61.4519 90.3231 61.3106 90.9158L58.8268 108.089C58.8268 108.089 58.8905 116.459 45.9519 116.459C33.0132 116.459 32.4606 108.089 32.4606 108.089Z",
    fill: "#9F9E8F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4606 108.089L29.9768 90.9158C29.9476 90.7932 29.9326 90.664 29.9326 90.5338C29.9326 89.9046 30.2744 89.3945 30.6959 89.3945H60.5915C60.6787 89.3945 60.7652 89.4168 60.8474 89.4605C61.2446 89.6715 61.4519 90.3231 61.3106 90.9158L58.8268 108.089C58.8268 108.089 57.3502 114.131 45.9519 114.131C34.5536 114.131 32.4606 108.089 32.4606 108.089Z",
    fill: "#C0BFB4"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.644,
    cy: 90.2695,
    rx: 15.7112,
    ry: 3.49217,
    fill: "#9F9E8F"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.6441,
    cy: 91.4375,
    rx: 13.8628,
    ry: 2.32811,
    fill: "#32312B"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12031_25093)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.4345 25.5323L72.1388 23.6492L77.7948 27.586C74.0138 32.2825 70.0857 37.3482 69.7226 43.3353C69.6001 45.287 69.3445 47.1375 68.9269 48.8687L60.3093 50.6308L58.0651 51.0889L60.9425 51.3157L68.0381 51.8802C67.5417 53.2585 66.9581 54.554 66.2754 55.7522C63.0934 61.3926 57.5048 77.77 51.4217 78.6862C51.4217 78.6862 51.4217 78.6862 51.4163 78.6862C51.2299 78.3344 42.5143 62.1884 50.5615 37.4968C51.6325 34.2208 53.047 31.1671 54.6962 28.3542C54.7506 28.2574 54.8043 28.169 54.8587 28.0767C64.6304 11.6296 82.3465 3.65815 84.7728 12.0416C86.1031 16.6261 83.1033 20.9427 79.4345 25.5323Z",
    fill: "#3A8761"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.2752 55.7497C61.4775 70.2727 57.5047 77.7674 51.4215 78.6836C51.4215 78.6836 51.4215 78.6836 51.4161 78.6836C51.1706 78.6836 37.8395 78.5036 49.4378 39.0392C50.4096 35.7356 52.9733 31.2568 54.696 28.3517C54.7504 28.2549 54.8041 28.1665 54.8585 28.0742C54.3328 32.2333 54.0927 38.4285 56.0275 44.0402C56.0275 44.0402 57.3577 47.2003 60.3091 50.6283L58.0649 51.0864L60.9423 51.3132C62.3711 52.8631 64.1392 54.4406 66.2752 55.7497Z",
    fill: "#2A5B43"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.944 41.229L49.9329 44.6367L54.036 43.4656C54.3454 55.3051 52.0767 66.5599 45.981 67.5982C37.8938 68.9861 33.3655 48.6579 33.0847 34.3404L38.8657 35.7609L33.1367 32.1933C33.1642 31.3035 33.2179 28.7214 33.2926 27.9313C34.0924 19.509 37.0982 10.9241 42.4908 5.57812C45.8472 10.8093 48.7138 16.8346 50.7435 22.8019C52.4483 27.7861 53.5928 34.5047 53.944 41.229Z",
    fill: "#3A8761"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.2893 27.929L50.7444 22.7974C48.7207 16.8352 45.8433 10.8104 42.4905 5.57812C37.102 10.9213 34.0873 19.5118 33.2893 27.929Z",
    fill: "#2A5B43"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.2773 27.933C36.0878 22.8713 40.631 20.4923 45.5022 18.8478L44.0041 11.1409L47.5278 18.2074C54.7859 16.058 62.4048 14.9409 66.1118 8.76984C66.9899 7.31389 66.2898 5.48987 65.0103 4.31362C63.8205 3.21448 62.1587 2.2324 60.2102 1.55536L51.5663 4.01365L56.3455 0.685277C47.385 -0.330569 35.6762 5.11392 33.2773 27.933Z",
    fill: "#89B59F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.1112 75.8205C37.4998 77.5995 29.7501 68.1473 23.7923 55.7663C23.4536 55.0443 23.1138 54.3222 22.7751 53.5771C22.1336 52.1554 21.5159 50.6995 20.9359 49.221L24.6567 48.6504L19.8111 46.2523C17.199 38.9399 15.4877 31.3539 15.4996 24.8711L33.34 28.2344C37.5828 34.7943 41.042 43.9065 43.092 52.4205L41.2588 57.4007L43.8279 55.7326C45.8624 65.85 45.676 74.4523 42.1112 75.8205Z",
    fill: "#2A5B43"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.3402 28.2347C33.3402 28.2347 29.4737 27.5768 25.4418 29.8342L19.2099 26.6144L24.0273 30.7611C22.9007 31.5986 21.7957 32.6876 20.788 34.1289C20.6721 34.2927 20.5562 34.4457 20.4403 34.6095C18.9799 33.5661 17.0613 32.2739 16.8749 32.1535L19.1143 36.3356C11.9822 44.8676 2.71884 46.7389 4.91999 38.441C5.37098 36.7425 5.78791 34.7913 6.50172 32.5913L10.8891 29.716L7.28183 30.2766C7.53689 29.5815 7.63067 29.4059 7.87258 29.0198C10.0056 25.687 14.003 23.8314 18.1329 24.0121C23.3111 24.2507 30.835 25.1275 33.3402 28.2347Z",
    fill: "#89B59F"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9427 13.4375C69.316 20.362 54.6166 34.211 48.8333 91.4293",
    stroke: "#89B59F",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6389 18.0938C44.2159 37.4355 48.5967 79.2976 45.5043 92.0114",
    stroke: "#89B59F",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6885 30.8945C28.3426 40.806 42.0945 66.7883 43.869 91.4255",
    stroke: "#89B59F",
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12031_25093"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 85.6414,
    height: 79.1559,
    fill: "white",
    transform: "translate(0.358643 0.0507812)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlant);
export default __webpack_public_path__ + "static/media/plant.f9b9ba1928a3786583beb16708296f79.svg";
export { ForwardRef as ReactComponent };